import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { useLocationId } from '@/data/useLocationId';
import { kpiApi } from '../api/kpiApi';

export function useKpiToday(date?: string, options?: { enabled?: boolean }) {
  const locationId = useLocationId();
  return useQuery({
    queryKey: keys.kpi.today(locationId ?? 0, date),
    queryFn: ({ signal }) => kpiApi.getToday(locationId!, date, { signal }),
    enabled: (options?.enabled ?? true) && locationId != null,
    staleTime: 60_000,
    refetchOnMount: 'always',
  });
}
